<template>
  <input
    :value="formattedValue"
    @input="handleInput"
    @blur="handleBlur"
    type="text"
    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
    :placeholder="placeholder"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: 'MoneyInput',
  props: {
    modelValue: {
      type: [Number, String],
      default: 0
    },
    placeholder: {
      type: String,
      default: '0,00'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: '',
      isEditing: false
    }
  },
  computed: {
    formattedValue() {
      return this.isEditing ? this.localValue : this.formatNumber(this.modelValue)
    }
  },
  methods: {
    formatNumber(value) {
      if (!value && value !== 0) return ''
      
      // Convertir a número
      let number = typeof value === 'string' 
        ? parseFloat(value.replace(/[^\d.,]/g, '').replace(',', '.')) 
        : value

      if (isNaN(number)) return ''

      // Formatear el número
      const parts = number.toFixed(2).split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')

      return parts.join(',')
    },
    handleInput(event) {
      this.isEditing = true
      let value = event.target.value

      // Permitir solo números, comas, puntos y borrar caracteres
      value = value.replace(/[^\d.,]/g, '')

      // Manejar múltiples separadores decimales
      const decimalCount = (value.match(/[.,]/g) || []).length
      if (decimalCount > 1) {
        const lastIndex = value.lastIndexOf(/[.,]/)
        value = value.slice(0, lastIndex) + value.slice(lastIndex + 1)
      }

      this.localValue = value

      // Convertir para el valor interno
      let numberValue = value.replace(/\./g, '').replace(',', '.')
      numberValue = parseFloat(numberValue)

      if (!isNaN(numberValue)) {
        this.$emit('update:modelValue', numberValue)
      }
    },
    handleBlur() {
      this.isEditing = false
      // Formatear el valor al perder el foco
      this.localValue = this.formatNumber(this.modelValue)
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newValue) {
        if (!this.isEditing) {
          this.localValue = this.formatNumber(newValue)
        }
      }
    }
  }
}
</script> 